export { default as component } from "../../../../src/routes/[prefix]/(main)/product/+page.svelte";